import { useLocation } from "react-router-dom";
import { Section, PageHero } from "@/components/common";

const COPY = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Friends of Satish Chapagain respects your privacy. We collect only the information you choose to share with us through our forms \u2014 such as your name, email, phone number, and address \u2014 to communicate with you about the campaign, process volunteer requests, and comply with Maryland campaign finance law.",
      "We do not sell your personal information. We may share data with service providers who help us operate the campaign. If you provide a mobile number and consent, you may receive recurring campaign text messages; reply STOP to opt out at any time.",
      "Donations are processed by ActBlue, which maintains its own privacy policy. Questions? Contact info@satishchapagain.com.",
    ],
  },
  terms: {
    title: "Terms of Use",
    body: [
      "By using this website you agree to use it lawfully and respectfully. Content on this site is provided for informational purposes about the campaign of Satish Chapagain for Maryland State Delegate, District 7A.",
      "All donations are handled by ActBlue and subject to federal and Maryland campaign finance regulations, including required contribution limits and disclosure of donor information.",
      "This site may link to third-party websites (such as the Maryland State Board of Elections and ActBlue); we are not responsible for their content.",
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const type = pathname.includes("terms") ? "terms" : "privacy";
  const c = COPY[type] || COPY.privacy;
  return (
    <div>
      <PageHero title={c.title} />
      <Section className="py-14">
        <div className="max-w-3xl space-y-5">
          {c.body.map((p, i) => <p key={i} className="text-slate-700 leading-relaxed">{p}</p>)}
          <p className="text-sm text-slate-400 pt-4">By Authority of Friends of Satish Chapagain, Treasurer.</p>
        </div>
      </Section>
    </div>
  );
}
